import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { BannerVideo } from '../../typings/domain';
import { GridBannerImage } from '../GridBannerImage/GridBannerImage';

import './GridBannerVideoAdvCell.css';
import * as keyset from './GridBannerVideoAdvCell.i18n';

export interface GridBannerVideoAdvCellProps {
    id: string;
    video: BannerVideo;
    onShowPreview?: () => void;
}

const i18n = i18nFactory(keyset);
const BLOCK = 'grid-banner-video-adv-cell';

export class GridBannerVideoAdvCell extends React.PureComponent<
    GridBannerVideoAdvCellProps
> {
    render() {
        const { id, video, onShowPreview } = this.props;
        const { name } = video;

        return (
            <div className={Bem.cls(BLOCK)}>
                <GridBannerImage
                    cls={Bem.cls(BLOCK, 'image')}
                    image={video}
                    onClick={onShowPreview}
                />

                <div className={Bem.cls(BLOCK, 'info')}>
                    <div className={Bem.cls(BLOCK, 'name')}>{name}</div>
                    <div className={Bem.cls(BLOCK, 'id')}>
                        {i18n('banner-id', { id })}
                    </div>
                </div>
            </div>
        );
    }
}
